import { render } from "./PlanillaDet - copia.vue?vue&type=template&id=713516a6&scoped=true"
import script from "./PlanillaDet - copia.vue?vue&type=script&lang=js"
export * from "./PlanillaDet - copia.vue?vue&type=script&lang=js"

import "./PlanillaDet - copia.vue?vue&type=style&index=0&id=713516a6&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713516a6"]])

export default __exports__